export default __webpack_public_path__ + "static/media/alend.755d8004.svg";